module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/arrow-right-black.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/arrow-right-black.png
// module id = 1503
// module chunks = 418